import { SubAPI } from "./SubAPI";
export class Manufacturing extends SubAPI {
    listLogs(props) { return this.fetcher.get("/api/manufacturing/logs", props); }
    getLog(props) { return this.fetcher.get("/api/manufacturing/log", props); }
    convertProducts(input) { return this.fetcher.post("/api/manufacturing/convert-products", input); }
    removePoItem(props) { return this.fetcher.post("/api/manufacturing/remove-po-item", props); }
    listWeldShopPos(props) { return this.fetcher.get("/api/manufacturing/weld-shop-pos", props); }
    getWeldShopPo(props) { return this.fetcher.get("/api/manufacturing/weld-shop-po", props); }
    listWeldShopPoItems(props) { return this.fetcher.get("/api/manufacturing/weld-shop-po/items", props); }
    configureBuild(input) { return this.fetcher.post("/api/manufacturing/build/configure", input); }
    completeBuild(input) { return this.fetcher.post("/api/manufacturing/build/complete", input); }
    submitToLogistics(input) { return this.fetcher.post("/api/manufacturing/build/purchase-components/submit-to-logistics", input); }
    listPurchaseComponents(props) { return this.fetcher.get("/api/manufacturing/build/purchase-components", props); }
    resetBuild(input) { return this.fetcher.post("/api/manufacturing/build/reset", input); }
    suggestBuildSteps(input) { return this.fetcher.post("/api/manufacturing/build/suggest", input); }
    searchBuildItems(input) { return this.fetcher.get("/api/manufacturing/search-build-items", input); }
    upsertPreset(input) { return this.fetcher.post("/api/manufacturing/preset", input); }
    listPresets(input) { return this.fetcher.get("/api/manufacturing/presets", input); }
}
export const todoPrepPrefix = "prep:";
